module.exports = __webpack_public_path__ + "img/Helfer_Kf.32a84eb7.svg";